import { render, staticRenderFns } from "./QVersion.vue?vue&type=template&id=55b8b81a&scoped=true&"
import script from "./QVersion.vue?vue&type=script&lang=js&"
export * from "./QVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8b81a",
  null
  
)

export default component.exports